module.exports = __webpack_public_path__ + "static/amare_img_33_h-2947f5e149d9f20880582b154196e901.jpg";